import { render, staticRenderFns } from "./IssueModal.vue?vue&type=template&id=3a1072d8&scoped=true"
import script from "./IssueModal.vue?vue&type=script&lang=js"
export * from "./IssueModal.vue?vue&type=script&lang=js"
import style0 from "./IssueModal.vue?vue&type=style&index=0&id=3a1072d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a1072d8",
  null
  
)

export default component.exports